import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade-up reveal on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (used in hero). `lines` is an array of strings/nodes.
export const LineReveal = ({ lines, className = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="line-mask">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Overline = ({ children, dark = false, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] ${
      dark ? "text-bone/60" : "text-stone"
    } ${className}`}
  >
    <span className={`h-px w-8 ${dark ? "bg-bone/40" : "bg-stone/50"}`} />
    {children}
  </span>
);
